import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get cargo assigners
 * */
function* getCargoAssigners() {
    const response = yield call(api.getCargoAssigners);

    if (!response) {
        yield put({
            type: actionTypes.GET_CARGO_ASSIGNERS.FAILURE,
            errors: [{ field: 'Could not load cargoAssigners' }],
        });

        return;
    }

    if (response && response.status === 200) {
        yield put({
            type: actionTypes.GET_CARGO_ASSIGNERS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_CARGO_ASSIGNERS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCargoAssigners() {
    while (true) {
        yield take(actionTypes.GET_CARGO_ASSIGNERS.REQUEST);
        yield fork(getCargoAssigners);
    }
}

/**
 * Get cargo assigners post request
 * */
function* getCargoAssignersPost(realCargoIds) {
    const response = yield call(api.getCargoAssignersPost, realCargoIds);

    if (!response) {
        yield put({
            type: actionTypes.GET_CARGO_ASSIGNERS_POST.FAILURE,
            errors: [{ field: 'Could not load cargoAssigners' }],
        });

        return;
    }

    if (response && response.status === 200) {
        yield put({
            type: actionTypes.GET_CARGO_ASSIGNERS_POST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_CARGO_ASSIGNERS_POST.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetCargoAssignersPost() {
    while (true) {
        const { realCargoIds } = yield take(actionTypes.GET_CARGO_ASSIGNERS_POST.REQUEST);
        yield fork(getCargoAssignersPost, realCargoIds);
    }
}

/**
 * Update cargo assigner
 * */
function* updateCargoAssigner(item) {
    const response = yield call(api.updateCargoAssigner, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_CARGO_ASSIGNER.SUCCESS,
            item: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.data.value} updated`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.UPDATE_CARGO_ASSIGNER.FAILURE,
        item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors ? response.errors[0].messages[0] : 'Something went wrong',
            level: 'error',
            _id: item,
            autoDismiss: 2,
        },
    });
}

export function* watchUpdateCargoAssigner() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_CARGO_ASSIGNER.REQUEST);
        yield fork(updateCargoAssigner, item);
    }
}


export default [
    watchGetCargoAssigners,
    watchUpdateCargoAssigner,
    watchGetCargoAssignersPost,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/assigners.js